import { Button, Modal, ModalBody, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';

import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function ModalDeslogar(props) {
  const disclosure = props.disclosure;
  const { setUser } = useContext(AccountContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api(`${ENDPOINT}/auth/logout`, {
        method: 'GET',
        credentials: 'include',
      });
      const postMessageReactNative = {
        event: 'logout',
      };
      localStorage.removeItem('token');
      window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessageReactNative));
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalBody>
            <VStack align={'left'} borderBottom={'0.1px black'}>
              <Text color={'red'} mt={2} textAlign={'center'} fontSize={'1.2em'} fontWeight={'bold'}>
                Atenção
              </Text>
            </VStack>
            <VStack mb={'1em'}>
              <Text color={'#616161'} textAlign={'justify'} fontSize={'17px'} letterSpacing={'-0.05em'}>
                Sessão expirada. Faça login novamente para continuar.
              </Text>
              <Button
                w={'100%'}
                color={'white'}
                borderRadius={'0.8em'}
                bg={'#5ab2ae'}
                onClick={() => {
                  setUser((prevState) => ({ loggedIn: false, build: prevState.build ? prevState.build : null }));
                  handleLogout();
                  navigate('/dashboard');
                  disclosure.onClose()
                }}
              >
                Entendi
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalDeslogar;
